import { RouteStatus } from './core';
import { SimplePort } from './port';

export enum RouteDay {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export interface Route {
  id: string;
  portOfDeparture: SimplePort;
  portOfArrival: SimplePort;
  dateFrom: string; // Datetime (YYYY-MM-DDTHH:mm:ss)
  dateTo: string; // Datetime (YYYY-MM-DDTHH:mm:ss)
  departureTime: string; // Time (HH:mm:ss)
  routeStatus: RouteStatus;
  repeatedOnDays: RouteDay[];
}

export interface SimpleRoute {
  id: string;
  portOfDepartureId: string;
  portOfArrivalId: string;
  dateFrom: string; // Datetime (YYYY-MM-DDTHH:mm:ss)
  dateTo: string; // Datetime (YYYY-MM-DDTHH:mm:ss)
  departureTime: string; // Time (HH:mm:ss)
  repeatOnDays: RouteDay[];
}

export type SimpleNewRoute = Omit<SimpleRoute, 'id'>;
